/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_sku = {
    readonly shipmentDeliveryEstimations: ReadonlyArray<{
        readonly shipmentQuoteId: string | null;
        readonly maxDaysToDeliver: number | null;
    } | null> | null;
    readonly " $refType": "PdpSharedShippingHolidayDelivery_sku";
};
export type PdpSharedShippingHolidayDelivery_sku$data = PdpSharedShippingHolidayDelivery_sku;
export type PdpSharedShippingHolidayDelivery_sku$key = {
    readonly " $data"?: PdpSharedShippingHolidayDelivery_sku$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingHolidayDelivery_sku",
  "type": "ItemSkuType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentDeliveryEstimations",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentDeliveryEstimationsType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shipmentQuoteId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "maxDaysToDeliver",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'cc6cdbc25b821df61bdc75928ae92ff4';
export default node;
